import { Check } from 'lucide-react';
import { cn } from '../lib/utils';

export const SelectableCard = ({
  value,
  label,
  description,
  icon: Icon,
  selected,
  onClick,
  testId
}) => {
  return (
    <button
      type="button"
      data-testid={testId || `option-${value}`}
      onClick={() => onClick(value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick(value);
        }
      }}
      className={cn(
        'bonza-selectable-card relative w-full text-left rounded-xl p-4 transition-all',
        'focus:outline-none focus:ring-2 focus:ring-[#5a2f92] focus:ring-offset-2',
        selected && 'selected'
      )}
      aria-pressed={selected}
    >
      <div className="flex items-start gap-3">
        {Icon && (
          <div className={cn(
            'flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center',
            selected ? 'bg-[#5a2f92] text-white' : 'bg-[#F3F0F8] text-[#5a2f92]'
          )}>
            <Icon className="w-5 h-5" />
          </div>
        )}
        <div className="flex-grow min-w-0">
          <div className="flex items-center justify-between gap-2">
            <span className={cn(
              'font-medium text-[0.9375rem] leading-tight',
              selected ? 'text-[#5a2f92]' : 'text-[#1A1523]'
            )}>
              {label}
            </span>
            {selected && (
              <div className="flex-shrink-0 w-5 h-5 rounded-full bg-[#5a2f92] flex items-center justify-center">
                <Check className="w-3 h-3 text-white" />
              </div>
            )}
          </div>
          {description && (
            <p className="mt-1 text-sm text-[#64748B] leading-snug">
              {description}
            </p>
          )}
        </div>
      </div>
    </button>
  );
};
